<template>
  <basic-dialog
    :show="show"
    @close="$emit('close')"
    max-width="1100px"
    draggable
  >
    <template v-slot:title>Generate Purchase invoices</template>

    <v-data-table
      :headers="headers"
      :items="items"
      :loading="$apollo.loading"
      v-bind="pagingOptions"
      v-model="selected"
      item-key="uid"
      show-select
    >
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox
            :input-value="props.selected"
            primary
            hide-details
          ></v-checkbox>
        </td>
        <td class="text-xs-left">{{ props.item.supplierName }}</td>
        <td class="text-xs-left">{{ props.item.serviceType }}</td>
      </template>
    </v-data-table>
    <template v-slot:actions>
      <v-btn
        color="primary"
        :disabled="selected == 0 || generating"
        :loading="generating"
        @click="onGenerate"
        >Generate</v-btn
      >
    </template>
  </basic-dialog>
</template>

<script>
import {
  ITINERARY_INVOICE_SUPPLIERS_QUERY,
  GENERATE_PURCHASE_INVOICES_MUTATION,
} from "../../../constants/graphql";

import { pagingOptions } from "../../../helpers/index";
import BasicDialog from "../shared/BasicDialog";
const randomize = require("randomatic");

export default {
  name: "ItineraryDetailsSuppliersListDialog",

  props: {
    itineraryId: {
      type: String,
      default: "",
    },
    show: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog },

  data() {
    return {
      debug: false,
      pagingOptions,
      headers: [
        {
          text: "Supplier Name",
          align: "left",
          value: "supplierName",
          sortable: false,
          name: "supplierName",
        },
        {
          text: "Supplier Type",
          align: "left",
          value: "serviceType",
          sortable: false,
          name: "serviceType",
        },
      ],
      selected: [],
      generating: false,
    };
  },
  computed: {
    items() {
      return this.itineraryInvoiceSuppliers
        ? this.itineraryInvoiceSuppliers.edges.map((s) => ({
            uid: randomize("Aa0", 32),
            ...s.node,
          }))
        : [];
    },
  },

  methods: {
    onGenerate() {
      if (this.generating) return;
      this.generating = true;
      this.$apollo
        .mutate({
          mutation: GENERATE_PURCHASE_INVOICES_MUTATION,
          variables: {
            itineraryId: this.itineraryId,
            suppliers: this.selected.map((item) => item.id),
          },
        })
        .then((res) => {
          this.$store.dispatch("showAppSnackbar", {
            msg: "Generation Complete",
            color: "success",
          });
          this.$emit("generated");
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.generating = false;
        });
    },
  },

  apollo: {
    itineraryInvoiceSuppliers: {
      query: ITINERARY_INVOICE_SUPPLIERS_QUERY,
      variables() {
        return {
          itineraryId: this.itineraryId,
        };
      },
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped>
#outer {
  overflow: auto;
  max-height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/ItineraryDetailsSuppliersListDialog.vue